import Facebook from "../components/Icons/Facebook";
import Instagram from "../components/Icons/Instagram";
import Linkedin from "../components/Icons/Linkedin";
import Youtube from "../components/Icons/Youtube";
import Youtube2 from "../components/Icons/Youtube2";
import { ScrollBehavior } from "./type";
import { JobFilters } from "../types";

export const ROUTES = {
  HOME: {
    label: "Home",
    path: "/",
    heading: "",
  },
  ABOUT: {
    label: "About Us",
    path: "/about",
    heading: "About Dutton Automotive",
  },
  CAREER: {
    label: "Careers",
    path: "/careers",
    heading: "Careers at dutton automotive",
  },
  CONTACT: {
    label: "Contact",
    path: "/contact",
    heading: "Contact Us",
  },
  TERMS_CONDITIONS: {
    label: "Wholesale Master Supply Terms and Conditions",
    path: "/wholesale-dealer-master-supply-terms-and-conditions",
    heading: "Wholesale Dealer Master Supply Terms And Conditions",
  },
  POLICY_SUBPAGE: {
    label: "",
    path: "/policies/:slug",
    heading: "",
  },
  POLICIES: {
    label: "Privacy Policy",
    path: "/policies",
    heading: "Policies",
  },
};

export const LOADER_COLOR = "#666666";
export const LOADER_SIZE = 20;

export interface DrawerItem {
  label: string;
  path: string;
}

export const MENU_ITEMS: DrawerItem[] = [
  { label: "Dutton Garage", path: "/garage" },
  { label: "Dutton Wholesale", path: "/wholesale" },
  { label: "Dutton One", path: "/dutton-one" },
  { label: "Sell Your Car Fast", path: "/sell-car" },
  { label: "Auto Mega Warehouse", path: "/auto-warehouse" },
  { label: "Dutton Financial Services", path: "/finance" },
  { label: "Targa Australia", path: "/targa" },
  { label: "Dutton Procurement", path: "/procurement" },
  { label: "Classic Throttle Shop", path: "/classic-throttle" },
  { label: "Dutton Labs LK", path: "/labs-lk" },
];

export const FOOTER_MENU_ITEMS: any[] = [
  { label: "About Us", path: ROUTES.ABOUT.path },
  { label: "Careers", path: ROUTES.CAREER.path },
  { label: "Contact Us", path: ROUTES.CONTACT.path },
  { label: "Privacy Policy", path: ROUTES.POLICIES.path },
  {
    label: "Wholesale Master Supply Terms and Conditions",
    path: ROUTES.TERMS_CONDITIONS.path,
  },
];

export const SOCIAL_LINKS: any[] = [
  {
    icon: Facebook,
    label: "Facebook",
    url: "https://www.facebook.com/duttongroup",
  },
  {
    icon: Youtube,
    label: "YouTube",
    url: "https://www.youtube.com/@duttongroup",
  },
  {
    icon: Linkedin,
    label: "Linkedin",
    url: "https://www.linkedin.com/company/duttongroup",
  },
  {
    icon: Instagram,
    label: "Instagram",
    url: "https://www.instagram.com/duttongroup",
  },
];

export const reducerKeys = {
  CMS_STORE: "cms-store",
  NEWSLETTER_STORE: "news-letter-store",
};

export const breakpoints = {
  sm: 576,
  md: 768,
  width375: 375,
  width390: 390,
  width414: 414,
  width430: 430,
  width500: 500,
  width820: 820,
  width932: 932,
  width1024: 1024,
  width1180: 1180,
  width1200: 1200,
  width1250: 1250,
  width1439: 1439,
  width1440: 1440,
  xl: 1200,
  xxl: 1400,
};

export const contactFormFields: any = {
  FULL_NAME: "fullName",
  EMAIL: "email",
  PHONE: "phone",
  MESSAGE: "message",
  ENQUIRY: "enquiry",
  TERMS: "terms",
  BRAND: "brand",
  STATE: "state",
  SITE_LOCATION: "location",
  MAKE: "make",
  MODEL: "model",
  YEAR: "year",
  ODOMETER: "odometer",
  VIN: "vin",
};

export const selectedEnquiryOptions = {
  BUY_A_CAR: "Buy a Car",
  SELL_YOUR_CAR: "Sell My Car",
  SERVICE_REPAIRS: "Service & Repairs",
};

export const ENQUIRY_OPTIONS_VALUES = {
  BUY_A_CAR: "EQ001",
  SELL_YOUR_CAR: "EQ002",
  SERVICE_REPAIRS: "EQ003",
  CAREERS_AND_OPPORTUNITIES: 'EQ004',
  PARTNERSHIPS_AND_BUSINESS: 'EQ005',
  GENERAL_ENQUIRY: 'EQ006'
};

export const ENQUIRY_OPTIONS_LABELS = {
  BUY_A_CAR: "Buy a Car",
  SELL_YOUR_CAR: "Sell My Car",
  CAREERS_AND_OPPORTUNITIES: 'Careers & Opportunities',
  PARTNERSHIPS_AND_BUSINESS: 'Partnerships & Business',
  GENERAL_ENQUIRY: 'General Enquiry'
};

export const enquiryOptions = [
  { id: 1, label: ENQUIRY_OPTIONS_LABELS.BUY_A_CAR },
  { id: 2, label: ENQUIRY_OPTIONS_LABELS.SELL_YOUR_CAR },
  { id: 3, label: ENQUIRY_OPTIONS_LABELS.CAREERS_AND_OPPORTUNITIES },
  { id: 4, label: ENQUIRY_OPTIONS_LABELS.PARTNERSHIPS_AND_BUSINESS },
  { id: 5, label: ENQUIRY_OPTIONS_LABELS.GENERAL_ENQUIRY },
];

// export const enquiryOptions = [
//   { id: 1, label: selectedEnquiryOptions.BUY_A_CAR },
//   { id: 2, label: selectedEnquiryOptions.SELL_YOUR_CAR },
//   { id: 3, label: "Careers & Opportunities" },
//   { id: 4, label: "Partnerships & Business" },
//   { id: 5, label: "General Enquiry" },
// ];

export const newsLetterFormFields: any = {
  NAME: "name",
  EMAIL: "email",
};

export const contactFormLabel: any = {
  FULL_NAME: "Full Name",
  EMAIL: "E-mail",
  PHONE: "Phone",
  MESSAGE: "Message",
  ENQUIRY: "Enquiry",
  TERMS: "terms",
  BRAND: "Brand",
  STATE: "State",
  SITE_LOCATION: "Site/Location",
  MAKE: "Make",
  MODEL: "Model",
  YEAR: "Year",
  ODOMETER: "Odometer (km)",
  VIN: "VIN (if known)",
};

export const contactFormPlaceholders: Record<string, string> = {
  FULL_NAME: "Ex: Johnathan Ive",
  EMAIL: "name@domain.com",
  MESSAGE: "Message (max 500 characters)",
  MAKE: "Vehicle Make",
  MODEL: "Vehicle Model",
  YEAR: "Manufacture Year",
  ODOMETER: "Enter odometer reading",
  VIN: "Enter 17-character VIN",
};

export const newsLetterFormLabel: any = {
  NAME: "Full Name",
  EMAIL: "Email Address",
};

export const CONTACT_TERM_TEXT = `
I’d like to receive updates about Dutton Automotive’s products, services, and events.
I understand these messages may be tailored to my interests and may include requests for feedback.
`;

export const ITEMS_PER_LOAD = 3;

export const MODAL_COMPONENT = {
  DETAILS_IMAGE: "details-with-image.detail-with-image",
  VIDEO_LIST: "video-list.video-list",
  DETAILS_BG_IMAGE:
    "details-with-background-image.details-with-background-image",
  DETAILS_TOP_HEADING: "details-with-top-heading.details-with-top-heading",
  DETAILS_IMAGE_HEADING:
    "details-with-heading-image.details-with-heading-image",
  SERVICE: "brand-service.brand-service",
  SERVICE_WITH_DETAILS: "brand-service-details.brand-service-with-details",
};

export const SOCIAL_ICONS: Record<string, React.FC> = {
  Facebook: Facebook,
  Youtube: Youtube2,
  Linkedin: Linkedin,
  Instagram: Instagram,
};

export const httpMethods = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  PATCH: "PATCH",
  DELETE: "DELETE",
};

export const IMAGE_ALT = {
  BRAND_LOGO: "Brand Logo",
  DUTTON_IMAGE: "Dutton Automotive Logo",
  HEADING_IMAGE: "Heading Image",
  TEAM_IMAGE: "Team Image",
  HOME_BRAND_BANNER :"Home Brand Image"
};

export const CUSTOM_SCROLL = {
  MIN_HEIGHT: 30,
  INSET: 100,
};

export const LIMITS = {
  VIDEO_LIMIT: 1,
  BRAND_MENU_LIMIT: 6,
  OFFER_CARDS_LIMIT: 5,
  VALUES_CARDS_LIMIT: 7,
};

export const DROPDOWN_DEFAULT = "No values found";

export const ERRORS = {
  YOUTUBE_ERROR: "Invalid YouTube link",
  VALID_EMAIL: "Please enter a valid email address.",
  VALID_NAME: "Please enter a valid name.",
  REQUIRED_FIELD: "This field is required.",
  FETCH_ERROR: "Error fetching brand:",
  VALID_PHONE: "Invalid Phone number link:",
  BRANDS: "Error loading brands, states or locations:",
  STATES: "Error loading brands, states or locations:",
  LOCATION: "Error loading brands, states or locations:",
  CSRF_MISSING: "CSRF token missing in response",
  JOB_LIST_FETCHING: "Unable to load job listings.",
};

export const allowMethods = ["post", "put", "patch", "delete", "get"];

export const FormErrors = {
  FULL_NAME_REQUIRED: "Full Name is required",
  FULL_NAME_TOO_LONG: "Full Name is too long",
  EMAIL_REQUIRED: "E-mail is required",
  EMAIL_INVALID: "Please enter a valid email",
  PHONE_REQUIRED: "Phone number is required",
  PHONE_INVALID: "Please enter a valid phone number",
  PHONE_TOO_SHORT: "Phone number is too short",
  ENQUIRY_REQUIRED: "Please select an enquiry type",
  BRAND_REQUIRED: "Brand is required",
  STATE_REQUIRED: "State is required",
  YEAR_INVALID_FORMAT: "Year must be 4 digits",
  YEAR_CANNOT_BE_FUTURE: "Year cannot be in the future",
  YEAR_CANNOT_BE_TOO_OLD: "Year cannot be before 1900",
  MESSAGE_TOO_LONG: "Message is too long",
  MESSAGE_REQUIRED: "Message is required",
  STRING_INVALID: "Please use only letters (A–Z, a–z) and numbers (0–9). Special characters are not allowed.",
  ONLY_STRING_INVALID: "Please use only letters (A–Z, a–z). Special characters and numbers are not allowed.",
  TERMS_REQUIRED: "You must accept the terms and conditions",
  ODOMETER_INVALID: "Please enter a valid odometer reading",
  VIN_INVALID: "Please enter a valid VIN",
  MAKE_INVALID: "Please enter a valid make",
  MODEL_INVALID: "Please enter a valid model",
  TERMS_INVALID: "Terms field must be a boolean",
};

export const COPYRIGHT = "Dutton Automotive 2026 ©";
export const DROPDOWN_PLACEHOLDER = { id: "0", label: "Not applicable" };

export const CAREERS_PAGE_SECTIONS = {
  SECTION_ONE: {
    title: "What We Stand For",
    key: "WHAT_WE_STAND",
  },
  SECTION_TWO: {
    title: "Why Work With Us",
    key: "WHY_WORK_WITH_US",
  },
  SECTION_THREE: {
    title: "Our People",
    key: "OUR_PEOPLE",
  },
  SECTION_FOUR: {
    title: "Join Our Team",
    key: "JOIN_OUR_TEAM",
  },
};

export const ERROR_MESSAGES = {
  FETCH_ABOUT_PAGE: "Failed to fetch About Page",
  FETCH_HOME_PAGE: "Failed to fetch Home Page",
  FETCH_TERMS_PAGE: "Failed to fetch Terms & Condition Page",
  FETCH_PRIVACY_POLICY: "Failed to fetch Privacy Policy",
  FETCH_CAREER_PAGE: "Failed to fetch Career Page",
  FETCH_FOOTER: "Failed to fetch Footer",
  FETCH_TEAM: "Failed to fetch Team",
  FETCH_TIMELINE: "Failed to fetch Timeline",
  FETCH_ROUTE_LIST: "Failed to fetch Timeline",
  FETCH_OUR_PEOPLES: "Failed to fetch OurPeoples",
  FETCH_BRANDS: "Failed to fetch Brands",
  NETWORK_RESPONSE_NOT_OK: "Network response was not ok",
  CANCEL_PREVIOUS_REQUEST: "Cancel previous request",
  ERROR_INVALID_HTTP_METHOD: "Invalid HTTP method",
  SUBMIT_FAIL: "Submission failed",
  CONTACT_US_FAILED: "Submit contact failed",
  FETCH_POLICY: "Failed to fetch Policies",
  POLICY_SUBPAGE_FAILED: "Failed to fetch Policy Subpage",
  FETCH_CONTACT_SECTION: "Failed to fetch Contact Section",
  FETCH_ENQUIRY_OPTIONS: "Failed to fetch Enquiry Options",
};

export const SUCCESS_MAIL = "Sucess to send email";

export const DEFAULT_VIDEO_PROPS = {
  autoPlay: true,
  muted: true,
  loop: true,
  playsInline: true,
  preload: "auto" as const,
};

export const MAX_LIMIT = {
  MESSAGE_TEXT_AREA: 500,
  VIN: 25,
  ODOMETER: 7,
  YEAR: 5,
};

export const MIN_PHONE_NUMBER_LENGTH = 6;
export const HTTP_STATUS_OK = 200;
export const HTTP_STATUS_CREATED = 201;

export const DRAWER_TRANSITITION = 600;
export const DRAWER_ANIMATION_DELAY = 50;

export const SCROLL: { BEHAVIOR: ScrollBehavior; TOP: number } = {
  BEHAVIOR: "smooth",
  TOP: 0,
};

export const DEFAULT_VALUES = {
  BACKGROUND_COLOR: "#000000",
  DEFAULT_VALUE_STRING: "",
};

export const MOTION_MODE = "manual";

export const MODAL_TYPE = {
  SECONDARY: "secondary",
};
export const HOME_LAYOUT_ID = "scrollable-container";

export const SCREEN_BREAKPOINTS = {
  SMALL: 780,
  MEDIUM: 1512,
  LARGE: 1920,
};

export const DRAWER_HEIGHT = {
  OTHER_LAYOUT_HEIGHT: "calc(100vh - 100px)",
  DEFAULT_HEIGHT: "540px",
};

export const IMAGE_ALT_NAMES = {
  TIME_LINE: "Timeline Icon",
};

export const getTimelineSectionConfig = () => {
  const isTabletOrMobile =
    typeof window !== "undefined" && window.innerWidth <= 768;

  return {
    baseItems: 4,
    container: {
      baseWidth: isTabletOrMobile ? 1450 : 2200,
      extraWidthPerItem: isTabletOrMobile ? 280 : 260,
    },
    line: {
      baseWidth: isTabletOrMobile ? 1090 : 1935,
      extraWidthPerItem: isTabletOrMobile ? 288 : 260,
    },
  };
};

export const baseFontSize = 16;

export const GA_EVENTS = {
  CONTACT_PAGE_VIEW: "contact_page_view",
  CONTACT_FORM_SUBMIT_SUCCESS: "contact_form_submit_success",
  CONTACT_FORM_SUBMIT_FAIL: "contact_form_submit_fail",
  NEWS_LETTER : "subscription",
} as const

export const PAGE_TITLES = {
  HOME: "Home | Dutton Automotive",
  ABOUT: "About | Dutton Automotive",
  CAREER: "Career | Dutton Automotive",
  CONTACT: "Contact | Dutton Automotive",
  PRIVACY_POLICY: "Privacy Policy | Dutton Automotive",
  TERMS_AND_CONDITIONS: "Terms and Conditions | Dutton Automotive",
  POLICY_SUBPAGE: "Policy Sub Page | Dutton Automotive",
} as const;

export const PAGE_META_DESCRIPTION = {
  DEFAULT: "Discover Dutton Automotive, a leading Australian automotive group offering quality vehicles, prestige and luxury cars, automotive services and more."
} as const;

export const SPECIAL_WORDS = ["DUTTON AUTOMOTIVE"];

export const TOP_COUNTRIES = ['au'];

export const MAX_CHARACTER_LIMITS = {
  NAME: 30,
  EMAIL: 50,
  MESSAGE: 500,
  VIN: 17,
  YEAR: 4,
  MAKE: 30,
  MODEL: 30
} as const;

export const CONTACT_RECAPTCHA_ACTION = "contact_form";

export const JOB_LIST_PAGE_SIZE = 10;

export const JOB_LIST_DEFAULT_FILTERS: JobFilters = {
  searchTitle: "",
  employmentType: "all",
  region: "all",
  brand: "all",
};

export const BRAND_JOB_FIELD_LABEL = "Brands";